export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4636.a280f249.jpg";